import { useFocus } from 'core-components/hooks/useFocus'
import { IInputProps, Input } from 'core-components/library/inputs'
import { FinancialBeautifiedValue } from 'partner360/components/financialBeautifiedValue/FinancialBeautifiedValue'

interface IProps extends IInputProps {
  className?: string
  showOnlyBeautifiedValue?: boolean
}

export const FinancialInput = ({ showOnlyBeautifiedValue, ...props }: IProps) => {
  const { focused, onFocus, onBlur } = useFocus(0)

  if (showOnlyBeautifiedValue) {
    return <FinancialBeautifiedValue value={props.value} className={props.className} />
  }
  if (focused) {
    return (
      <Input
        {...props}
        classes={{ root: props.className }}
        onFocus={onFocus}
        onBlur={onBlur}
        autoFocus={true}
      />
    )
  }
  return (
    <div tabIndex={1} onFocus={onFocus} onBlur={onBlur}>
      <FinancialBeautifiedValue value={props.value} className={props.className} />
    </div>
  )
}
